'use strict'

import {getCurrentUser} from '../security/browser/CurrentUser.js'

const widgetList = require('../widgets/_index')
const blocks = require('../blocks/_index')
const ajax = require('../helpers/ajax')
const modal = new (require('../helpers/modal'))
const pageEditor = require('./page')
const Login = require('./login')

class Editor {

	constructor() {
		let urlKey = 'page'
		this.iframe = document.querySelector('iframe')

		this.iframe.src =
			(this.urlParams(window.location.search)[urlKey] || '/') +
			window.location.search
		this.iframe.onload = () => {
			this.init()
			let path = this.iframe.contentDocument.location.pathname
			let query = this.toQuery(this.iframe.contentDocument.location.search)
			history.replaceState({}, null, '?' + urlKey + '=' + path +
				'&' + query)

			this.iframe.contentWindow.onunload = () => {
				document.querySelector('#main').innerHTML = `
					<div class="editor">
						<div class="title">
							<span class="name">Nahrávam</span>
							${path}
						</div>
					</div>
				`
			}
		}
	}

	init() {
		this.doc = this.iframe.contentDocument
		this.widgets = this.doc.querySelectorAll('[mbry-widget]')
		this.sections = this.doc.querySelectorAll('[mbry-section]')
		this.setupIframe()
	}

	urlParams(uri) {
		let queryString = {}
		uri.replace(
			/([^?=&]+)(=([^&]*))?/g,
			($0, $1, $2, $3) => { queryString[$1] = $3 }
		)
		return queryString
	}

	toQuery(url) {
		const obj = this.urlParams(url)
		const arr = []
		delete obj.page
		Object.keys(obj).forEach(key => {
			arr.push(key + '=' + obj[key])
		})
		return arr.join('&')
	}

	setupIframe() {
		if (!this.doc.querySelector('[mbry-page-id]')) {
			window.console.error('EDITOR: no page id!')
			new pageEditor(this.doc, null)
			return
		}
		this.pageID = this.doc
			.querySelector('[mbry-page-id]')
			.getAttribute('mbry-page-id')

		this.getData(this.pageID).then(() => {
			this.injectCSS()
			this.injectButtons()
			new pageEditor(this.doc, this.article)
		})
	}

	injectCSS() {
		this.doc.querySelector('head').innerHTML +=`
			<link rel="stylesheet"
				href="https://fonts.googleapis.com/icon?family=Material+Icons">
			<link rel="stylesheet"
				href="/css/css_portal_edit.css">
		`
	}

	injectButtons() {
		this.widgets.forEach((el) => {
			this.injectEditButton(el)
		})
		this.sections.forEach((el) => {
			this.injectAddButton(el)
		})
	}

	injectAddButton(section) {
		if (getCurrentUser().hasPermission(_CONF_INSTANCE_ + ':portal-editor:change-article-block-add')) {
			let el = this.doc.createElement('div')
			el.className = 'edit-tools-add'
			let btn = this.doc.createElement('button')
			btn.className = 'btn'
			btn.innerHTML = '<i class="material-icons">add</i>'
			btn.onclick = () => this.addBlockModal(section)

			el.appendChild(btn)
			section.appendChild(el)
		}

	}

	injectEditButton(widget) {

		if (getCurrentUser().hasPermission(_CONF_INSTANCE_ + ':portal-editor:change-article-block-edit')) {
			let el = this.doc.createElement('div')
			if (
				!widget.parentNode.getAttribute('mbry-block-id') &&
				widget.parentNode.getAttribute('mbry-block') !== 'menu'
			) { return }
			el.className = 'edit-tools-edit'
			let btn = this.doc.createElement('button')
			btn.className = 'btn'
			btn.innerHTML = '<i class="material-icons">mode_edit</i>'
			btn.onclick = () => this.initWidget(widget)

			el.appendChild(btn)
			widget.appendChild(el)
		}
	}

	getNewBlockId() {
		let max = 0
		this.article.data.forEach(item => {
			if (item.meta.pageBlockId > max) {
				max = item.meta.pageBlockId
			}
		})
		return max + 1
	}

	activateScripts(node) {
		const scripts = node.querySelectorAll('script')
		scripts.forEach(script => {
			let ins = this.doc.createElement('script')
			if (script.src) { ins.src = script.src }
			ins.type = 'text/javascript'
			ins.innerHTML = script.innerText
			script.parentNode.insertBefore(ins, script)
			script.remove()
		})
	}

	addBlockModal(section) {
		const div = document.createElement('div')
		const sectionType = section.getAttribute('mbry-section-type')
		const groups = this.block2groups(sectionType)

		Object.keys(groups).forEach(group => {

			const title = document.createElement('h2')
			title.innerHTML = group
			title.className = 'blocklist-title'
			div.appendChild(title)

			const ul = document.createElement('ul')
			ul.className = 'blocklist'
			div.appendChild(ul)

			groups[group].forEach(config => {

				const li = document.createElement('li')
				li.innerHTML = `<a>
					<span class="icon">${config.icon||'<i class="material-icons">chevron_right</i>'}</span>
					<span class="name">${config.name}</span>
				</a>`
				ul.appendChild(li)
				li.querySelector('a').onclick = () => {
					const newdata = {
						data: this.newWidgetData(config),
						meta: {
							name: config._block,
							pageBlockId: this.getNewBlockId(),
							sectionName: section.getAttribute('mbry-section'),
						}
					}

					this.renderBlock(newdata).then(block => {
						this.article.data.push(newdata)
						section.insertBefore(block, section.querySelector('.edit-tools-add'))
						block.querySelectorAll('[mbry-widget]').forEach(el => {
							this.injectEditButton(el)
						})
						this.activateScripts(block)
						this.initWidget(block.querySelector('[mbry-widget]'))
						this.saveData()
					})

					modal.hide()
				}
			})
		})

		modal.show('Pridať widget', div)
	}

	block2groups(sectionType) {
		const groups = {}
		const other = []
		Object.keys(blocks).forEach(key => {

			const block = blocks[key]
			if (block._sections.indexOf(sectionType) === -1) { return }

			if (!block._groups) {
				other.push(block)
				return
			}
			block._groups.forEach(group => {
				if (!groups[group]) { groups[group] = [] }
				groups[group].push(block)
			})
		})

		if (other.length > 0) {
			groups['Ostatné'] = other
		}
		return groups
	}

	renderBlock(blockdata) {
		const search = this.iframe.contentDocument.defaultView.location.search
		if (blockdata.meta.name === 'menu') {
			blockdata.data = this.menu.index
		}
		return new Promise(fulfill => {
			ajax({
				method: 'PUT',
				url: '/article/-/' + this.article._id + search,
				dataType: 'application/json',
				data: {
					block: blockdata,
				},
			}).then(html => {
				const div = document.createElement('div')
				div.innerHTML = html
				fulfill(div.firstElementChild)
			})
		})
	}

	newWidgetData(config) {
		const data = []
		config.widget.forEach((widget) => {
			data.push(Object.assign({}, widget.initData) || {})
		})
		return config.widget.length < 2 ? data[0] : data
	}

	initWidget(widget) {

		this.doc.body.classList.add('editing')
		let blockconfig = blocks[widget.parentNode.getAttribute('mbry-block')]
		if (!blockconfig) {	blockconfig = {widget: [{type: 'base'}]} }

		const index = widget.getAttribute('mbry-widget')
		const type = blockconfig.widget[index].type
		this.widgets.forEach((el) => {
			el.classList.remove('active')
			el.parentNode.classList.remove('active')
		})
		widget.classList.add('active')
		widget.parentNode.classList.add('active')

		if (this.activeWidget && typeof this.activeWidget.onDestroy === 'function') {
			this.activeWidget.onDestroy()
		}

		const blockData = this.getBlockData(widget)


		this.activeWidgetEl = widget
		this.activeWidget = new widgetList[type](
			this,
			this.doc,
			blockconfig.widget[index],
			this.getWidgetData(blockconfig, blockData, index),
			blockData,
			widget,
			[blockconfig.name, index]
		)

		this.activeWidget._onSave = btn => {
			btn.disabled = true
			this.saveData().then(() => {
				btn.disabled = false
			})
		}

		this.activeWidget._onClose = () => {
			new pageEditor(this.doc, this.article)
		}

		this.activeWidget._onDelete = () => {
			const block = this.getBlockData(this.activeWidgetEl)
			this.doc.querySelector(
				'[mbry-block-id="' + block.meta.pageBlockId + '"]').remove()
			this.article.data.splice(this.article.data.indexOf(block), 1)
		}

		const dataCopy = JSON.parse(JSON.stringify(this.article.data))
		const menuCopy = JSON.parse(JSON.stringify(this.menu))
		this.activeWidget._originalData = () => {
			this.menu = menuCopy
			this.article.data = dataCopy
		}

	}

	move(direction, sortUp, sortDown) {
		const sect = this.activeWidgetEl.parentNode.parentNode.getAttribute('mbry-section')
		const block = this.getBlockData(this.activeWidgetEl)
		const section = this.article.data.filter(item => {
			return (item.meta.sectionName === sect) ||
				(!item.meta.sectionName && sect === 'default') ||
				(item.meta.sectionName === 'default' && !sect)
		})
		const index_data = this.article.data.indexOf(block)
		const index_section = section.indexOf(block)

		if (direction < 0) {
			let item = this.article.data.splice(index_data, 1)[0]
			let prev = this.article.data.indexOf(section[index_section - 1])
			this.article.data.splice(prev, 0, item)

			let x = this.doc.querySelector('[mbry-block-id="' +
				item.meta.pageBlockId + '"]')
			x.parentNode.insertBefore(x, x.previousElementSibling)

			x.scrollIntoViewIfNeeded()
			this.move(0, sortUp, sortDown)
			return
		}

		if (direction > 0) {
			let item = this.article.data.splice(index_data, 1)[0]
			let next = this.article.data.indexOf(section[index_section + 1])
			this.article.data.splice(next + 1, 0, item)

			let x = this.doc.querySelector('[mbry-block-id="' +
				item.meta.pageBlockId + '"]')
			x.parentNode.insertBefore(x, x.nextElementSibling.nextElementSibling)

			x.scrollIntoViewIfNeeded()
			this.move(0, sortUp, sortDown)
			return
		}

		if (section.indexOf(block) === 0) {
			sortUp.disabled = true
		} else {
			sortUp.disabled = false
		}

		if (section.indexOf(block) === section.length - 1) {
			sortDown.disabled = true
		} else {
			sortDown.disabled = false
		}

	}

	getBlockData(widget) {
		let data
		let id = parseInt(widget.parentNode.getAttribute('mbry-block-id'))
		this.article.data.forEach((block) => {
			if (block.meta.pageBlockId === id) {
				data = block
			}
		})
		return data
	}

	getWidgetData(blockconfig, blockdata, index) {
		if (blockconfig._block === 'menu') {
			return this.menu.index
		}
		if (blockconfig.widget.length < 2) {
			return blockdata.data
		} else {
			return blockdata.data[index]
		}
	}

	camelCase(str) {
		return str.replace(/(?:^\w|[A-Z]|\b\w)/g, (letter, index) => {
			return index === 0 ? letter.toLowerCase() : letter.toUpperCase()
		}).replace(/\s+/g, '')
	}

	getData(id) {

		return Promise.all([

			ajax({
				url: '/api/article/' + id,
			}).then(resp => {
				this.article = resp
			}),

			ajax({
				url: '/api/menu/' + id,
			}).then(resp => {
				this.menu = resp
			})

		])

	}

	saveData() {

	console.log("fdfdfdf",document)

		this.autoFillTitle()

		this.assignedArticle()

		return Promise.all([

			ajax({
				method: 'PUT',
				url: '/api/article',
				dataType: 'application/json',
				data: this.article,
			}),

			ajax({
				method: 'PUT',
				url: '/api/menu',
				dataType: 'application/json',
				data: this.menu,
			}),

		])


	}


	assignedArticle() {


		const today = new Date().toLocaleDateString();
		const today2 = new Date();
		const time = today2.getHours() + ":" + today2.getMinutes();
		if (document.querySelector("iframe").contentWindow.document.getElementById("today")) {
			var myDiv = document.querySelector("iframe").contentWindow.document.getElementById("today")
			myDiv.innerHTML = `${today}`
		}
		if (document.querySelector("iframe").contentWindow.document.getElementById("time")) {
			var myDiv2 = document.querySelector("iframe").contentWindow.document.getElementById("time")
			myDiv2.innerHTML = `${time}`


		}

	}

	autoFillTitle() {
		if (this.article.meta.title) { return }
		let title
		let final
		this.article.data.forEach(block => {
			if (final) { return }
			if (block.meta.name === 'title') {
				title = this.autoFillTitleParser(block)
				final = true
			}
			if (block.data.html && !title) {
				title = this.autoFillTitleParser(block)
			}
		})
		window.console.log(title)
		this.article.meta.title = title || ''
	}

	autoFillTitleParser(block) {
		const el = document.createElement('div')
		el.innerHTML = block.data.html
		const words = el.innerText.match(/^((?:\S+\s+){1,4}\S+)/)
		if (words) {
			return words[0].trim()
		}
		return ''
	}

}


window.addEventListener('load', () => {
	if (window.location.pathname === '/editor') {
		window.editor = new Editor()
	} else {
		new Login()
	}
})



//////////////////
// WEBPACK FOOTER
// ./src/editor/editor.js
// module id = 409
// module chunks = 0